import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { isLocationAvailableWithAffirm } from '../../../../../../api/Utils/affirmUtils';
import { isValidPrice } from '../../../../../../utilities/cmpPackagesUtils';
import { SupAmount } from '../../../../../ui-kit';
import theme from '../../../../../ui-kit/themes/theme';
import { handleTotal } from '../../../../../utilities/utils';
import { SummaryContent } from '../../../Content';
import * as COPY from '../../utilities/copy';
import { AffirmLink } from './AffirmLink';

const propTypes = {
  /** Flag to indicate if the user has packages selected */
  hasSelectedPackages: PropTypes.bool,

  /** Subtotal for the current reservation */
  summaryTotal: PropTypes.number.isRequired,

  /** loyalty points balance */
  pointAmount: PropTypes.number,

  /** loyalty boolean to show or not the value */
  loyaltyOptIn: PropTypes.bool
};

export const Subtotal = ({
  hasSelectedPackages,
  summaryTotal,
  pointAmount,
  loyaltyOptIn,
  showLoyalty,
  userOffers,
  activeOffers,
  suiteTotal,
  isUserAuthenticated,
  currentSelectedPackages,
  setExcedent,
  resortLocation,
  isTaxOnlyMessage,
  shouldSavePoints,
  taxesAndFees,
  hasSuitePriceIncludedTaxesAndFees
}) => {
  const [refreshAffirm, setRefreshAffirm] = useState(new Date().getTime());
  const suiteTotalWithPrivateLodgingFee = hasSuitePriceIncludedTaxesAndFees
    ? (summaryTotal + taxesAndFees?.find(taxesAndFee => taxesAndFee.name.includes('Lodging'))?.amount).toFixed(2)
    : undefined;

  const handleSummarySubTotal = isUserAuthenticated
    ? handleTotal(
        userOffers,
        activeOffers,
        showLoyalty,
        loyaltyOptIn,
        shouldSavePoints ? 0 : pointAmount,
        suiteTotal,
        currentSelectedPackages,
        setExcedent
      ).toFixed(2)
    : summaryTotal?.toFixed(2);

  const handleSummarySubTotalWithTaxes = hasSuitePriceIncludedTaxesAndFees
    ? suiteTotalWithPrivateLodgingFee
    : handleSummarySubTotal;

  useEffect(() => {
    setRefreshAffirm(new Date().getTime());
  }, [hasSelectedPackages, summaryTotal, handleSummarySubTotal]);

  return isValidPrice(summaryTotal) ? (
    <>
      <SummaryContent.Divider />

      <SummaryContent.Item
        fontWeight={theme.fontWeights.bold}
        fontSize={['18px', null, null, '18px']}
        mb="4px"
        lineHeight={'22px'}>
        <SummaryContent.Description>{COPY.SUBTOTAL}</SummaryContent.Description>
        <SummaryContent.SubtotalAmount fontWeight="bold">
          <SupAmount
            fontSize={7}
            textToUse={`$${hasSuitePriceIncludedTaxesAndFees ? handleSummarySubTotalWithTaxes : handleSummarySubTotal}`}
            avoidFormat={true}
          />
        </SummaryContent.SubtotalAmount>
      </SummaryContent.Item>
      <SummaryContent.Item mb="14px" fontSize={['10px', null, null, '10px']} lineHeight="16px">
        <SummaryContent.Description lineHeight="16px" justifyContent="flex-end">
          ({isTaxOnlyMessage ? COPY.TAXES_ONLY_MESSAGE : COPY.TAXES_NOT_INCLUDED})
        </SummaryContent.Description>
      </SummaryContent.Item>
      {isLocationAvailableWithAffirm(resortLocation) ? (
        <SummaryContent.Item mb={`${theme.space[7]}px`}>
          <AffirmLink
            refreshAffirm={Boolean(refreshAffirm)}
            summaryTotal={hasSuitePriceIncludedTaxesAndFees ? handleSummarySubTotalWithTaxes : handleSummarySubTotal}
            resortLocation={resortLocation}
          />
        </SummaryContent.Item>
      ) : null}
    </>
  ) : null;
};
Subtotal.propTypes = propTypes;
Subtotal.defaultProps = {
  hasSelectedPackages: false,
  pointAmount: 0,
  loyaltyOptIn: false
};
